import {Component, OnInit, OnDestroy ,ViewChild} from '@angular/core';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {FieldType, Filters, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {MessageService} from '../message.service';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'app-admin-auth',
  templateUrl: './admin-auth.component.html',
  styleUrls: ['./admin-auth.component.css']
})
export class AdminAuthComponent implements OnInit, OnDestroy {

  displayed = true;
  totalData = 0;
  show: boolean;
  selected: number;
  userSelected: number;
  users: any;
  modules: any;
  displayData: any;
  clientId: number;
  addChecked: boolean;
  deleteChecked: boolean;
  editChecked: boolean;
  viewChecked: boolean;

  private respObject: any;
  isError = false;
  errorMessage: string;
  private userName: any;

  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;
  private baseFlag: any;
  private adminAuth: Subscription;
  private notifier: NotifierService;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  dataLoaded:boolean;
  showSearch = true;
  isLoading = false;
  searchData: FormControl = new FormControl();
  moduleSelected: any;
  admins: any;
  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;





  constructor(private _rest: RestApiService,
              private messageService: MessageService, private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          console.log('deleted');
          if (!this.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteAdminUserAuth({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      } else {
        this.add = false;
        this.del = false;
        this.view = false;
        this.edit = false;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }

  get selectedOptions() {
    return this.modules
      .filter(opt => opt.checked)
      .map(opt => opt);
  }

  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.modules = [];
    this.messageService.setGridWidth(1000);

    this.displayData = {
      pageName: 'Maintain Platform User Authorization',
      openModalButton: 'Authorize Platform User',
      searchModalButton: 'Search',
      breadcrumb: 'PlatformUserAuthorization',
      folderName: 'All Authorized User',
      tabName: 'Authorized Platform User'
    };

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', maxWidth: 40, sortable: true, filterable: true},
      {
        id: 'user', name: 'User Name', field: 'name', sortable: true, filterable: true
      },
      {
        id: 'module', name: 'Module Name', field: 'module', sortable: true, filterable: true
      },
      {
        id: 'add', name: 'Add', field: 'addFlag', sortable: true, formatter: Formatters.checkmark,
        filter: {
          collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
          model: Filters.singleSelect,

          filterOptions: {
            autoDropWidth: true
          },
        }, filterable: true
      },
      {
        id: 'delete', name: 'Delete', field: 'deleteFlag', sortable: true, formatter: Formatters.checkmark,
        filter: {
          collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
          model: Filters.singleSelect,

          filterOptions: {
            autoDropWidth: true
          },
        }, filterable: true
      },
      {
        id: 'edit', name: 'Edit', field: 'editFlag', sortable: true, formatter: Formatters.checkmark,
        filter: {
          collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
          model: Filters.singleSelect,

          filterOptions: {
            autoDropWidth: true
          },
        }, filterable: true
      },
      {
        id: 'view', name: 'View', field: 'viewFlag', sortable: true, formatter: Formatters.checkmark,
        filter: {
          collection: [{value: '', label: 'All'}, {value: true, label: 'True'}, {value: false, label: 'False'}],
          model: Filters.singleSelect,

          filterOptions: {
            autoDropWidth: true
          },
        }, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }


    // this.searchData.valueChanges.subscribe(
    //   name => {
    //       if (name.length) {
    //           this.isLoading = true;
    //           this._rest.searchAllPlatformUserAuth(name, this.clientId).subscribe((res1) => {
    //               this.respObject = res1;
    //               this.isLoading = false;
    //               if (this.respObject.success) {
    //                   this.admins = this.respObject.details;
    //                   console.log("............"+JSON.stringify(this.admins));
    //               } else {
    //                   this.notifier.notify('error', this.respObject.errorMessage);
    //               }
    //           }, (err) => {
    //               this.isLoading = false;
    //               this.notifier.notify('error', this.messageService.SERVER_ERROR);
    //           });
    //       } else {
    //           this.admins = [];
    //       }
    //   });

  }

  onPageLoad() {
        this._rest.getUserClientWise(this.clientId).subscribe((res1) => {
          this.respObject = res1;
          if (this.respObject.success) {
            this.respObject.details.push({id: 0, name: 'Select User'});
            this.users = this.respObject.details;
          } else {

          }
        }, (err) => {

        });
        this.getTableData();
  }

  openModal(content) {
    if (!this.add) {
      console.log('no permission');
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.userSelected = 0;

      console.log('open');
      this.modalService.open(content, {}).result.then((result) => {
        console.log(result);
      }, (reason) => {
        console.log(reason);
      });
    }
  }


  searchModal() {
    if (!this.add) {
      console.log('no permission');
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.moduleSelected = '';

      console.log('open');
      this.searchModalReference = this.modalService.open(this.scarch_content);
      this.searchModalReference.result.then((result) => {
      }, (reason) => {

      });
}
  }




  search() {
    this._rest.searchAllPlatformUserAuth(this.moduleSelected, this.clientId).subscribe((res1) => {
        this.respObject = res1;
        this.isLoading = false;
        if (this.respObject.success) {
            this.admins = this.respObject.details;
            console.log(JSON.stringify(this.admins))
            this.messageService.setTotalData(this.admins.length);
            this.messageService.setGridData(this.admins);
            this.searchModalReference.close();

        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.isLoading = false;
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}


  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }


  save() {
    if (this.selectedOptions.length > 0 && this.userSelected !== 0) {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        this.selectedOptions[i].refer_user_id = this.userSelected;
        this.selectedOptions[i].createdBy = this.messageService.getUserId();
      }
      // console.log(JSON.stringify(this.selectedOptions));
      this._rest.setAdminUserAuth({data: this.selectedOptions}).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          this.nextOffset = 0;
          this.page_no = 0;
          this.getTableData();
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getAdminUserAuth(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }


  onUserChange(value: any) {
    this.userName = this.users[value].name;
    this.getAdminUserAuth();
  }

  getAdminUserAuth() {
    if (this.userSelected !== 0) {
      this._rest.getAdminUserAuthorization(this.userSelected).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          this.modules = this.respObject.details;
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    }
  }
  showOptions($event) {
  }

  checkAll(checked: boolean, i: any) {
    this.modules[i].addChecked = checked;
    this.modules[i].deleteChecked = checked;
    this.modules[i].viewChecked = checked;
    this.modules[i].editChecked = checked;
  }

  ngOnDestroy(): void {
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }
}
